"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePricingFilesMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.deletePricingFilesMutation = (0, graphql_tag_1.default) `
  mutation DeletePricingFiles($pricingFileIds: [ID!]!) {
    deletePricingFiles(pricingFileIds: $pricingFileIds)
  }
`;
//# sourceMappingURL=delete-pricing-files.js.map